import {
  Button,
  Grid,
  TextField,
  Typography,
  Container,
} from "@material-ui/core";
import React, { useState } from "react";
import WebStyles from "../../WebStyles.module.css";
import clsx from "clsx";
import HomeWebForm from "../home/HomeWebForm";

export default function MoreGreatFeatures({
  smUp,
  mdUp,
  lgUp,
  lgDown,
  xsDown,
  commonPadding,
}) {
  const [showWaitListForm, setShowWaitListForm] = useState(false);
  const handleClose = () => {
    setShowWaitListForm(false);
  };
  return (
    <Grid
      item
      container
      xs={12}
      style={{
        backgroundImage: lgUp
          ? "url('/images/service_providers/Blue_patch.svg')"
          : "none",
        backgroundRepeat: "no-repeat",
        backgroundSize: "10%",
        padding: commonPadding,
      }}
    >
      <HomeWebForm
        open={showWaitListForm}
        who={"serviceProvider"}
        handleClose={handleClose}
      ></HomeWebForm>
      <Container>
        <Grid
          item
          container
          xs={12}
          style={{
            paddingBottom: lgUp ? 60 : 24,
            paddingTop: 16,
            flexDirection: smUp ? "row" : "column-reverse",
          }}
        >
          <Grid
            item
            container
            xs={12}
            md={7}
            lg={6}
            style={{ alignContent: "center", zIndex: 1, position: "relative" }}
          >
            <div
              variant="inherit"
              className={clsx(WebStyles.blueHeaderTxt, WebStyles.hankrndFont)}
              style={{
                fontSize: mdUp ? 60 : 30,
                lineHeight: mdUp ? "74px" : "32px",
                textAlign: "left",
                marginBottom: 20,
                fontWeight: 600,
              }}
            >
              Increase your opportunities
            </div>
            <div
              variant="inherit"
              className={clsx(WebStyles.paraBlackText, WebStyles.barlowFont)}
              style={{
                fontSize: mdUp ? 28 : 14,
                lineHeight: mdUp ? "38px" : "19px",
                textAlign: "left",
                marginBottom: 24,
                paddingRight: 24,
              }}
            >
              {`Generate leads. Save time. Cut costs. Elevate your client
              experiences.`}
            </div>
            <Grid item container xs={12} alignItems="center">
              {/* <Grid
                item
                container
                xs={12}
                md={7}
                lg={7}
                style={{
                  marginBottom: mdUp ? 0 : 24,
                }}
              >
                <Grid item container xs={11}>
                  <TextField
                    fullWidth
                    id="standard-basic"
                    label="Your email"
                    inputProps={{
                      className: WebStyles.nunitoFont,
                    }}
                  />
                </Grid>
              </Grid> */}
              <Grid
                item
                container
                xs={12}
                md={5}
                lg={7}
                style={{
                  display: "flex",
                  justifyContent: mdUp ? "flex-start" : "flex-end",
                }}
              >
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#72CAC9",
                    borderRadius: mdUp ? 24 : 12,
                    padding: "8px 20px",
                    fontSize: mdUp ? 20 : 14,
                    textTransform: "none",
                    height: 50,
                    marginRight: xsDown && 24,
                  }}
                  onClick={() => {
                    // setShowWaitListForm(true);
                    window.open("https://app.souqh.ca/new", "_blank");
                  }}
                >
                  <Grid className={WebStyles.hankrndFont}>
                    Sign up now for free!
                  </Grid>
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            container
            xs={12}
            md={5}
            lg={6}
            style={{ justifyContent: "center" }}
          >
            <Grid
              container
              item
              xs={12}
              style={{
                width: "100%",
                height: smUp ? 570 : 370,
                justifyContent: "center",
                zIndex: 0,
                position: "relative",
              }}
            >
              <img
                style={{ height: "100%", width: "100%" }}
                src="/images/service_providers/people.svg"
                alt="opportunity"
              ></img>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
}
